import React from 'react'
import Dialog from '@mui/material/Dialog'
import { useForm } from 'react-hook-form'
import CommunityForm from './CommunityForm'
import { useSnackbar } from 'notistack'
import communityService from '../../../services/communityService'

const CreateCommunityPage = ({ open, onClose, submitOnSuccess }) => {
  const { enqueueSnackbar } = useSnackbar()

  const submitHandler = ({ id, description, heroImageUrl }) => {
    const form = { id, description, heroImageUrl }
    return communityService.createCommunity({
      ...form
    })
      .then(res => {
        onClose()
        submitOnSuccess()
        enqueueSnackbar('Successfully created a community!', { variant: 'success' })
      })
      .catch(err => enqueueSnackbar(err.response.data.message, { variant: 'error' }))
  }

  const methods = useForm({ mode: 'onChange' })

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <CommunityForm methods={methods} onSubmit={submitHandler} onClose={onClose} submitButtonLabel="Create"/>
    </Dialog>
  )
}

export default CreateCommunityPage
